import { useTranslation } from 'react-i18next';
import {
  PrimaryButton,
  DefaultButton,
  Icon,
  Spinner,
  SpinnerSize,
} from 'office-ui-fabric-react';

const draftPreviewButtonStyles = {
  root: {
    border: '0px',
    backgroundColor: '#F4F4F4',
  },
};

const goBackIconStyle = {
  fontSize: '12px',
  margin: '10px 0',
  marginRight: '10px',
  color: '#333333',
};

const CreateHearingWriteButtons = ({
  onClickPublish,
  onClickDraft,
  onClickPreview,
  onClickGoBack,
  isUpdatingHearing,
  disableSaveAsDraftButton,
  disablePublishButton,
}) => {
  const onClickGoBackLocal = () => !isUpdatingHearing && onClickGoBack();

  const { t: translator } = useTranslation();
  return (
    <div>
      <div className="create-hearing-buttons">
        <PrimaryButton
          text={translator('global.publish')}
          onClick={onClickPublish}
          disabled={isUpdatingHearing || disablePublishButton}
        />
        <div className="create-hearing-buttons-right">
          {isUpdatingHearing && <Spinner size={SpinnerSize.large} />}
          <DefaultButton
            text={translator('global.saveDraft')}
            styles={draftPreviewButtonStyles}
            onClick={onClickDraft}
            disabled={isUpdatingHearing || disableSaveAsDraftButton}
          />
          <DefaultButton
            text={translator('global.preview')}
            styles={draftPreviewButtonStyles}
            onClick={onClickPreview}
            disabled={isUpdatingHearing}
          />
        </div>
      </div>

      <button className="create-hearing-step-back" onClick={onClickGoBackLocal}>
        <Icon iconName="Back" className={goBackIconStyle} />
        <p>{translator('global.back')}</p>
      </button>
    </div>
  );
};

export { CreateHearingWriteButtons };
